import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export default async function GetMissingContexts(gtx: string[]) {
  let arrOfObjects: any[] = [];
  let found: string[] = [];
  let toFetch: string[] = [];
  let codes: any =
    JSON.parse(window.localStorage.getItem("context-keys")!) || [];
  for (let l of gtx) {
    for (let c of codes) {
      if (c.context === l) {
        arrOfObjects.push(c);
        found.push(l);
        break;
      }
    }
 
    if (!found.includes(l)) toFetch.push(l);
  }

  if (toFetch.length === 0) return arrOfObjects;

  const configGeneral: AxiosRequestConfig = {
    method: "POST",
    url: `${BASE_URL}/api/config`,
    data: {
      lang: "EN",
      contexts: toFetch,
    },
  };

  return await AXIOS_INSTANCE(configGeneral)
    .then((v) => {
      window.localStorage.setItem(
        "context-keys",
        JSON.stringify(codes.concat(v.data))
      );
      return arrOfObjects.concat(v.data);
    })
    .catch((err) => console.error(err));
}

export function determineConfig(
  codes: any[],
  ctx: string,
  code: string
): string {
  if (!codes || codes.length < 1) return "";
  let found = codes!.find((v: any) => v.context === ctx);
  if (!found) return "";
  return found.textCodes.find((v: any) => v.code === code)?.text;
}

export function determineConfigLong(
  codes: any[],
  ctx: string,
  code: string
): string {
  if (!codes || codes.length < 1) return "";
  let found = codes!.find((v: any) => v.context === ctx);
  if (!found) return "";
  return found.textCodes.find((v: any) => v.code === code)?.textLong;
}


export function displayConfig(
  codes: any[],
  ctx: string
): {code:string, text:string, textLong:string}[] {
  if (!codes || codes.length < 1) return [];
  let found = codes!.find((v: any) => v.context === ctx);
  if (!found) return [];
  return found.textCodes;
}

export   function getRequestStatus(status: string) {
let text='';
  if (status === "RP_REJECT") text = "Rejected";
  if (status === "RP_APPROVE") text = "Approved";
  if (status === "RP_QUEUE") text = "Pending Approval​";
    return text;
}